import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import MyButton from '../../util/MyButton';
import PostScream from '../scream/PostScream';
import Notifications from './Notifications';

// MUI stuff
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';

// Icons
import HomeIcon from '@material-ui/icons/Home';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import KeyboardReturn from '@material-ui/icons/KeyboardReturn';

//redux
import {logoutUser} from '../../redux/actions/userActions';

class Navbar extends Component {
  state = {
    collapse1: false,
    collapseID: ''
  };

  toggleCollapse = collapseID => () => {
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ''
    }));
  };

  toggleSingleCollapse = collapseId => {
    this.setState({
      ...this.state,
      [collapseId]: !this.state[collapseId]
    });
  };

  handleLogout = () => {
    this.props.logoutUser();
  };

  render() {
    const {authenticated} = this.props;

    return (
      <AppBar>
        <Toolbar className='nav-container'>
          {authenticated ? (
            <Fragment>
              <Link to='/'>
                <MyButton tip='Home'>
                  <HomeIcon />
                </MyButton>
              </Link>
              <PostScream />
              <Link to='/home'>
                <MyButton tip='Posts'>
                  <ChatOutlinedIcon />
                </MyButton>
              </Link>
              <Notifications />
              <Link to='/account'>
                <MyButton tip='Account'>
                  <AccountCircleIcon />
                </MyButton>
              </Link>
              <MyButton tip='Logout' onClick={this.handleLogout}>
                <KeyboardReturn color='primary' />
              </MyButton>
            </Fragment>
          ) : (
            <Fragment>
              {/* <MDBHamburgerToggler
                className='HamburgerToggler'
                color='#fff'
                id='hamburger1'
                onClick={() => this.toggleSingleCollapse('collapse1')}
              /> */}

              {/* <MDBCollapse isOpen={this.state.collapse1} navbar> */}
              {/* <MDBNavbarNav left> */}
              {/* <MDBNavItem active> */}
              <Button color='inherit' component={Link} to='/'>
                Home
              </Button>
              {/* </MDBNavItem> */}
              {/* <MDBNavItem> */}
              <Button color='inherit' component={Link} to='/about'>
                About
              </Button>
              {/* </MDBNavItem> */}
              {/* <MDBNavItem> */}
              <Button color='inherit' component={Link} to='/contact'>
                Contact
              </Button>
              {/* </MDBNavItem> */}
              {/* </MDBNavbarNav> */}
              {/* </MDBCollapse> */}
              <Button color='inherit' component={Link} to='/login'>
                Login
              </Button>
              <Button color='inherit' component={Link} to='/signup'>
                Signup
              </Button>
            </Fragment>
          )}
        </Toolbar>
      </AppBar>
    );
  }
}

Navbar.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
};
const mapActionsToProps = {logoutUser};

const mapStateToProps = state => ({
  authenticated: state.user.authenticated,
  user: state.user
});

export default connect(mapStateToProps, mapActionsToProps)(Navbar);
